export function calcularPaginasVisiveis(current, last, delta = 2) {
  const range = []
  const rangeWithDots = []

  for (let i = Math.max(2, current - delta); i <= Math.min(last - 1, current + delta); i++) {
    range.push(i)
  }

  if (current - delta > 2) {
    rangeWithDots.push(1, '...')
  } else {
    rangeWithDots.push(1)
  }

  rangeWithDots.push(...range)

  if (current + delta < last - 1) {
    rangeWithDots.push('...', last)
  } else {
    rangeWithDots.push(last)
  }

  return rangeWithDots.filter((v, i, a) => a.indexOf(v) === i)
}

export function formatToolName(toolName) {
  if (!toolName) return 'N/A'
  if (toolName === 'falha_envio_por_quantidade_de_tokens') {
    return 'Falha de envio por quantidade de tokens'
  }
  return toolName
    .replace(/_/g, ' ')
    .replace(/\b\w/g, l => l.toUpperCase())
}

export function formatarTempo(tempoMs) {
  if (!tempoMs || tempoMs === 0 || tempoMs === null || tempoMs === undefined) {
    return 'N/A'
  }

  const tempo = parseFloat(tempoMs)

  if (tempo < 1000) {
    return Math.round(tempo) + 'ms'
  }

  if (tempo < 60000) {
    return (tempo / 1000).toFixed(1) + 's'
  }

  return (tempo / 60000).toFixed(1) + 'min'
}

export function formatOperacao(operacao) {
  if (!operacao) return 'N/A'
  return operacao.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
}

export function formatarCusto(valor) {
  if (valor == null) return '0.0000'
  return Number(valor).toFixed(4)
}

export function formatarCustoGrafico(valor) {
  return '$' + Number(valor).toFixed(4)
}

export function formatarLatencia(ms) {
  if (!ms && ms !== 0) return 'N/A'
  if (ms < 1000) return Math.round(ms) + 'ms'
  return (ms / 1000).toFixed(1) + 's'
}

export function uniqueValues(lista) {
  return [...new Set((lista || []).filter(Boolean))]
}
